module.exports = __webpack_public_path__ + "img/62400.027cd678.jpg";